import moment from 'moment'
import { isNull } from 'lodash'; // 时间转换
export const getCookieLanguageCode = (req, app, redirect, store, route) => { // 获取语言取值
  // console.log(route, 77)
  const LanguageCode = 'LanguageCode'
  if (app.$cookies.get(LanguageCode)) { // 默认有cookie值取cookie的
    return route.fullPath != '/' ? redirect(302, `/${app.$cookies.get(LanguageCode)}/404.html`) : redirect(302, `/${app.$cookies.get(LanguageCode)}`)
  } else {
    const arr = (req.headers['user-agent'] && req.headers['user-agent'].split('|')[1]) ? req.headers['user-agent'].split('|')[1].split(',') : []
    const arrLan = arr[0]
    if (arrLan) { // 没有cookie值优先去cdn返回
      const lang = arrLan.split(':')[1]
      // app.$cookies.set(LanguageCode, lang, { path: '/', domain: hostS })
      return route.fullPath != '/' ? redirect(302, `/${lang}/404.html`) : redirect(302, `/${lang}`)
    }
    if (!arrLan) { // 加一个判断取浏览器语言判断是否有对应语言，没有取en
      const { langList = [] } = store.state
      // langList = langList ? langList : []
      const [browserLang] = [req?.headers['accept-language']?.split(',')[0]?.toLowerCase()] // 获取浏览器地址栏参数、获取浏览器的语言
      const [isBrowser] = [langList?.includes(browserLang)] // 浏览器地址栏的语言是否存在于语言列表中、浏览器语言是否存在于语言列表中
      const lang = isBrowser ? browserLang : 'en' // 设定的语言
      return route.fullPath != '/' ? redirect(302, `/${lang}/404.html`) : redirect(302, `/${lang}`)
    }
  }
}

export const getCookieCountryCode = async (req, app) => { // 获取国家取值
  const CountryCode = 'CountryCode'
  if (app.$cookies.get(CountryCode)) { // 取国家
    return app.$cookies.get(CountryCode)
  } else {
    // console.log(req.headers['user-agent'], 999123)
    const arr = (req.headers['user-agent'] && req.headers['user-agent'].split('|')[1]) ? req.headers['user-agent'].split('|')[1].split(',') : []
    const arrCoun = arr[1]
    if (arrCoun && arrCoun.split(':')[1]) {
      // const country = arrCoun.split(':')[1] ? arrCoun.split(':')[1] : 'us'
      // app.$cookies.set(CountryCode, country, { path: '/', domain: hostS })
      return arrCoun.split(':')[1] ? arrCoun.split(':')[1] : 'us'
    } else {
      // console.log(req.headers['x-forwarded-for'], 11123)
      const forwardedIp = req.headers['x-forwarded-for'] ? req.headers['x-forwarded-for'].split(',')[0] : '114.114.114.114'
      const userIp = await app.$axios.get(`http://ipinversion.fxeyeinterface.com/api/v1/getipgeo?ip=${forwardedIp}`).catch(() => { // 用户ip语言
        console.log('getipgeo', 989)
      })
      // console.log(userIp, 33321)
      const country = (userIp && userIp.data && userIp.data.data && userIp.data.data.country_code) ? userIp.data.data.country_code : 'cn'
      // app.$cookies.set(CountryCode, country.toLowerCase(), { path: '/', domain: hostS })
      return country
    }
  }
}

export const debounce = (fn, delay) => { // 防抖----多次快速点击提交后只会执行一次
  // 设置time为定时器
  let time = null
  // 闭包原理，返回一个函数
  return function (e) {
    // 如果定时器存在则清空定时器
    if (time) {
      clearTimeout(time)
    }
    // 设置定时器，规定时间后执行真实要执行的函数
    time = setTimeout(() => { // 此箭头函数里的this指向btn这个按钮
      fn.call(this, arguments) // 改变真实要执行函数的this指向，原submit函数里面的this指向window
    }, delay)
  }
}

/***
 * 节流函数 在wait间隔时间内不再进行任何调用时，触发一次最后的调用（如:wait设置为300ms，一直点击，该函数一直不执行，只有在间隔了300ms不做任何点击后，才执行刚才的最后一次点击）
 * @ func 执行函数
 * @ wait 等待时间
 * @ {Boolean} mustRun 是否立即执行
 * @return {Function}
 */
export const throttle = (func, wait, mustRun) => {
  // console.log('节流')
  let timeout
  let startTime = new Date()

  return function () {
    const context = this
    const args = arguments
    const curTime = new Date()

    clearTimeout(timeout)
    // 如果达到了规定的触发时间间隔，触发 handler
    if (curTime - startTime >= mustRun) {
      func.apply(context, args)
      startTime = curTime
      // 没达到触发间隔，重新设定定时器
    } else {
      timeout = setTimeout(func, wait)
    }
  }
}

export const iPhone = (req) => { // 判断pc还是移动-服务端判断true为pc；false为m站---参数为服务端req参数
  const userAgentInfo = req.headers['user-agent']
  const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod', 'FXEYE-BIB-IOS-WIKIFX', 'FXEYE- -ANDROID-WIKIFX']
  let flag = false
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo && userAgentInfo.includes(Agents[v])) {
      flag = true
      break
    }
  }
  return flag
}

export const getUrlState = (imgurl) => { // 判断图片链接是否可以访问
  return new Promise(function (resolve, reject) {
    const ImgObj = new Image()
    ImgObj.src = imgurl
    ImgObj.onload = function (res) {
      resolve(res)
    }
    ImgObj.onerror = function (err) {
      reject(err)
    }
  })
}

export const gatClick = () => { // 搜索点击统计
  window.gtag('event', 'click', {
    event_category: 'search',
    event_label: 'search broker'
  })
}

export const wikifxsearchGat = () => { // wikifx下的Pixel统计---搜索统计
  window._tfa.push({ notify: 'event', name: 'search broker', id: 1480928 })
}

export const wikifxtraderGat = () => { // wikifx下的Pixel统计---交易商详情页
  window._tfa.push({ notify: 'event', name: 'brokerpage', id: 1480928 })
}
export const serverlog = (err, route, store, $winstonLog) => { // 服务端日志
  try {
    const mttime = moment()
    const msg = `${mttime.format('YYYY-MM-DD HH:mm:ss.SSS')} ERROR [DATA-API-WEB]:{"Function":"asyncData","Url":"${route.fullPath}","CountryCode":"${store.state.CountryCode}","LanguageCode":"${store.state.LanguageCode}","HttpType":"${err.config && err.config.method}","HttpState":${err.response && err.response.status},"Time":0,"Parameter":${JSON.stringify(err.config && err.config.params)},"Message":"${err.message}","WikiRequestId":"${mttime.format('YYYYMMDDHHmmssSSS')}${(Math.random() * 899999).toString().replace('.', '')}"}`
    $winstonLog.log({
      level: 'error',
      message: msg.toString()
    })
  } catch (err) { }
}

export const jslog = (info, $winstonLog) => { // 客户端日志
  try {
    const mttime = moment()
    const message = (info && info.data && info.data.includes('{') && info.data.includes('}') ? info.data : '"' + info.data + '"')
    const msg = `${mttime.format('YYYY-MM-DD HH:mm:ss.SSS')} INFO3333333 [DATA-API-WEB]:{"Url":"${info.url}","wiki-bfp":"${info.zhiwen}","myCountry":"${info.myCountry}","Message":${message},"WikiRequestId":"${mttime.format('YYYYMMDDHHmmssSSS')}${(Math.random() * 899999).toString().replace('.', '')}"}`
    $winstonLog.info({
      level: 'info',
      message: msg
    })
  } catch (err) { }
}

export const jserrlog = (info) => {
  try {
    const xhr = new XMLHttpRequest()
    xhr.open('GET', '/zh-cn/api/log', true)
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
    xhr.setRequestHeader('mito-header', JSON.stringify(info))
    xhr.send(null)
  } catch (err) { }
}

export const fxlog = (message, url) => {
  try {
    const xhr = new XMLHttpRequest()
    xhr.open('GET', '/zh-cn/api/log', true)
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
    const info = {}
    info.url = url
    info.message = message
    xhr.setRequestHeader('mito-header', JSON.stringify(info))
    xhr.send(null)
  } catch (err) { }
}
// function sysTime () {
//   const myDate = new Date()
//   const year = myDate.getFullYear()
//   const month = myDate.getMonth() + 1
//   const date = myDate.getDate()
//   const h = myDate.getHours()
//   const m = myDate.getMinutes()
//   const s = myDate.getSeconds()
//   const now = year + '-' + (month < 10 ? '0' : '') + month + '-' + ((date < 10 ? '0' : '')) + date + ' ' + ((h < 10 ? '0' : '')) + h + ':' + ((m < 10 ? '0' : '')) + m + ':' + ((s < 10 ? '0' : '')) + s
//   return now
// }

// export const serverlog = () => { // 服务端日志
// const param = {
//   message: err.message,
//   level: 'asyncData',
//   type: 'asyncData',
//   page: route.fullPath,
//   CountryCode: store.state.CountryCode,
//   LanguageCode: store.state.LanguageCode
// }
// $winstonLog.error(param)

// const mttime = sysTime()
// const msg = `${mttime.format('YYYY-MM-DD HH:mm:ss.SSS')} ERROR [DATA-API-WEB]:{"Function":"asyncData","Url":"${route.fullPath}","CountryCode":"${store.state.CountryCode}","LanguageCode":"${store.state.LanguageCode}","HttpType":"${err.config.method}","HttpState":${err.response.status},"Time":0,"Parameter":${JSON.stringify(err.config.params)},"Message":"${err.message}","WikiRequestId":"${mttime.format('YYYYMMDDHHmmssSSS')}${(Math.random() * 899999).toString().replace('.', '')}"}`
// $winstonLog.error(msg.toString())
// }

/**
 * 将 dom 元素全屏
 * @param {dom} element dom元素
 * @example
 * setFullscreen(document.documentElement) // 整个页面进入全屏
 * setFullscreen(document.getElementById("id")) // 某个元素进入全屏
 */
export function setFullScreen (element) {
  if (element.requestFullscreen) {
    element.requestFullscreen()
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen()
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen()
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullScreen()
  }
}

/**
 * 退出全屏
 * @example
 * exitFullscreen();
 */
export function exitFullScreen () {
  if (!document.fullscreenElement) {
    return
  }
  if (document.exitFullscreen) {
    document.exitFullscreen()
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen()
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen()
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen()
  }
}
/**
 * 判断当前移动端浏览器是否为竖屏状态
 * @returns Boolean
 */
export function isVerticalScreen () {
  return window.orientation === 180 || window.orientation === 0
}


export const isH5ByAgent = (agent) => {
  if (isNull(agent)) return
  const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod', 'FXEYE-BIB-IOS-WIKIFX', 'FXEYE- -ANDROID-WIKIFX']
  let flag = false
  for (let v = 0; v < Agents.length; v++) {
    if (agent && agent.includes(Agents[v])) {
      flag = true
      break
    }
  }
  return flag
}

/**
 * 布尔值统一转 1 0
 * @param data
 * @returns {string|*}
 */
export const boolToString = (data) => {
  if (typeof data !== 'boolean') return data
  return data ? '1' : '0'
}

export const stringDeal = (data) => {
  if (data === null || data === undefined) return ''
  return data
}

export const setImg = (bool) => {
  // 图片懒加载图片处理bool为true滚动出发，false默认
  if (!document || !window) return
  const ele = document.getElementsByClassName('common-img')
  const windowHeight = window.innerHeight
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
  if (ele) {
    for (let i = 0; i < ele.length; i++) {
      if (bool) {
        ele[i].setAttribute('src', ele[i].getAttribute('xsrc'))
      } else {
        const top = ele[i].offsetTop > 100 ? ele[i].offsetTop : ele[i].parentNode.offsetTop
        if (top > 300 && top <= windowHeight + scrollTop) {
          ele[i].setAttribute('src', ele[i].getAttribute('xsrc'))
        }
      }
      const image = new Image()
      image.src = ele[i].getAttribute('xsrc')
      image.onerror = function (e) {
        // console.log(e);
        ele[i].setAttribute('src', ele[i].getAttribute('dg'))
      }
    }
  }
}

/**
 * 对象的key全部赚大小写
 * @param ob
 * @param type
 * @returns {{}|{}}
 */
export const objectKeyToLow = (ob, type = 'low') => {
  if (typeof ob !== 'object') throw new Error(`attributes is not obj: ${ob}`)
  return Object.keys(ob).length > 0
    ? Object.keys(ob)
      .reduce((prev, cur, i) => {
        // 对象值布尔值统一转 1 0
        ob[cur] = boolToString(ob[cur])
        // null 和 undefined 转 ''
        ob[cur] = stringDeal(ob[cur])
        // 对象key 转大小写
        prev[type === 'low'
          ? cur.toLocaleLowerCase()
          : cur.toLocaleUpperCase()] = ob[cur]; return prev
      }, {})
    : {}
}
